import { Group, QueryParams } from "@/sharedTypes";
import { baseApi } from "../baseApi";
import { flattenQueryParams } from "@/utils/requestUtils";

const groupTag = "Group";

export const groupApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createGroup: builder.mutation<Group, Partial<Group>>({
      query: (groupDetails) => ({
        url: `/groups`,
        method: "POST",
        body: groupDetails,
      }),
      invalidatesTags: [groupTag],
    }),
    getGroups: builder.query<any, QueryParams | void>({
      query: (params) => {
        const queryString = params
          ? `?${new URLSearchParams(flattenQueryParams(params)).toString()}`
          : "";
        return `/groups${queryString}`;
      },
      providesTags: [groupTag],
    }),
    getGroupById: builder.query<Group, string>({
      query: (id) => `/groups/${id}`,
      transformResponse: (response: any) => response.data,
      providesTags: (result, error, id) => [{ type: groupTag, id }],
    }),
    updateGroup: builder.mutation<Group, { groupId: string; updatedDetails: Partial<Group> }>({
      query: ({ groupId, updatedDetails }) => ({
        url: `/groups/${groupId}`,
        method: "PUT",
        body: updatedDetails,
      }),
      invalidatesTags: [groupTag],
    }),
    disableGroup: builder.mutation<void, string>({
      query: (id) => ({
        url: `/groups/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [groupTag],
    }),
    restoreGroup: builder.mutation<void, number>({
      query: (groupId) => ({
        url: `/groups/${groupId}/restore`,
        method: "PUT",
      }),
      invalidatesTags: [groupTag],
    }),
    hardDeleteGroup: builder.mutation<void, number>({
      query: (id) => ({
        url: `/groups/${id}/permanent`,
        method: "DELETE",
      }),
      invalidatesTags: [groupTag],
    }),
  }),
});

export const {
  useCreateGroupMutation,
  useGetGroupsQuery,
  useGetGroupByIdQuery,
  useUpdateGroupMutation,
  useDisableGroupMutation,
  useRestoreGroupMutation,
  useHardDeleteGroupMutation,
} = groupApi;
